import { SvgIcon } from '@mildang/mui';
import type { SvgIconProps } from '@mildang/mui';

const SvgLogoV2 = (props: SvgIconProps) => {
  return (
    <SvgIcon
      fill="none"
      viewBox="0 0 86 24"
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <clipPath id="a">
        <path d="M0 0h86v24H0z" />
      </clipPath>
      <g clipPath="url(#a)">
        <g fill="#2b2d36">
          <path d="M26.89 0h-5.944l-2.39 12.022h4.74l1.855-9.368zM18.033 2.603 19.723 0H4.57L2.182 12.022h13.971l1.881-9.419zm-5.66 6.247H6.838L7.972 3.12h5.81zM39.875 12.007l1.823-3.475H31.582l1.031-5.136h8.803L43.266 0H28.536L26.15 12.007zM1.52 16.392h16.573l-.168.85H1.351L0 24h20.844l.543-2.73H5.456l.25-1.064h15.889l1.356-6.828H2.111zM48.743 4.33l.344-1.676L51.079 0h-5.755l-2.448 12.3h4.3l.764-3.848H50l1.928-4.123zM42.53 13.281H31.317c-1.527 0-2.903.509-4.125 1.527-1.223 1.018-1.995 2.329-2.318 3.929-.32 1.599-.074 2.876.745 3.83.817.955 1.999 1.433 3.543 1.433h11.212c1.545 0 2.931-.482 4.159-1.446 1.23-.964 1.995-2.246 2.3-3.846.32-1.6.07-2.905-.751-3.914-.825-1.008-2.01-1.514-3.554-1.514zm-.031 5.407c-.113.568-.42 1.026-.924 1.366a2.817 2.817 0 0 1-1.609.513h-8.938c-.57 0-1.03-.16-1.381-.478-.35-.32-.467-.787-.355-1.4.139-.614.436-1.092.896-1.434.46-.343.984-.513 1.576-.513h8.935c.639 0 1.132.165 1.482.496.351.33.455.815.318 1.45z" />
        </g>
        <path
          d="M54.624 3.705 50.584 24h4.69l1.048-5.264h2.85c2.059 0 3.923-.66 5.595-1.976s2.756-3.218 3.249-5.708c.258-1.29.295-2.42.115-3.387l-.015-.069h6.005L71.332 24h4.317l2.788-16.404h4.962l2.04-3.891zm8.636 7.016c-.526 2.667-1.962 4.33-4.304 4.33h-1.868l1.537-8.063h1.964c1.099 0 1.89.278 2.373.835.482.559.582 1.524.3 2.897z"
          fill="#24bb54"
        />
      </g>
    </SvgIcon>
  );
};

export default SvgLogoV2;
